module.exports = __webpack_public_path__ + "img/simba_logo.2949920b.png";